import { render } from "./UpdateDesktopMasterVersion.vue?vue&type=template&id=75e18a3d&scoped=true"
import script from "./UpdateDesktopMasterVersion.vue?vue&type=script&lang=js"
export * from "./UpdateDesktopMasterVersion.vue?vue&type=script&lang=js"

import "./UpdateDesktopMasterVersion.vue?vue&type=style&index=0&id=75e18a3d&scoped=true&lang=less"

import exportComponent from "/root/mold/diplo/dist/rpmbuild/BUILD/cloudstack-4.21.0.0-Diplo-202603161407/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-75e18a3d"]])

export default __exports__